import { claimsDashboardActions } from './claimsDashboardActionCreator';

export const initialClaimsFilters = {
  status: null,
  reason: null,
  dateFilters: null,
  clientCode: '',
  rpCode: ''
};

const initialState = {
  isLoading: false,
  isSuccess: false,
  claimsData: [],
  totalElements: 0,
  pageNumber: 0,
  pageSize: 10,
  showPagination: false,
  search: '',
  filters: initialClaimsFilters
};

const claimsDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case claimsDashboardActions.SET_CLAIMS_DATA:
      return { ...state, ...action.payload };
    case claimsDashboardActions.UPDATE_PAGE_NUMBER:
      return { ...state, pageNumber: action.payload };
    case claimsDashboardActions.UPDATE_SEARCH:
      return { ...state, search: action.payload };
    case claimsDashboardActions.UPDATE_FILTER:
      return {
        ...state,
        filters: { ...state.filters, [action.key]: action.payload }
      };
    default:
      return state;
  }
};

export default claimsDashboardReducer;
